export const ConfigurationIdentifiers = {
  LODGING_DATED_PDP_CAROUSEL_FEATURED_HEADER_CHECK: 'lodging_dated_pdp:lodging_featured_header_check',
  LODGING_DATED_PDP_CAROUSEL_NO_FEATURED_HEADER_CHECK: 'lodging_dated_pdp:lodging_no_featured_header_check',
  LODGING_DATED_PDP_LODGING_FALLBACK: 'lodging_dated_pdp:lodging_fallback',
  LODGING_DATED_PDP_SPONSORED_PROPERTIES_CAROUSEL: 'lodging_dated_pdp:lodging_sponsored_properties',
  LODGING_DATED_PDP_CAROUSEL_HIGHLIGHTS: 'lodging_dated_pdp:lodging_highlights',
  LODGING_DATED_PDP_CAROUSEL_HIGHLIGHTS_FALLBACK: 'lodging_dated_pdp:lodging_highlights_fallback',
  LODGING_DATED_PDP_CAROUSEL_HIGHLIGHTS_NO_SUBTITLE: 'lodging_dated_pdp:lodging_highlights_no_subtitle',
  LODGING_DATED_PDP_CAROUSEL_HIGHLIGHTS_NO_SUBTITLE_FALLBACK: 'lodging_dated_pdp:lodging_highlights_no_subtitle_fallback'
};